import { useEffect, useState } from "react";
import { api, API, LOGO_URL } from "@/lib/api";

export function useDynamicLogo() {
  const [url, setUrl] = useState(LOGO_URL);
  useEffect(() => {
    api.get("/settings").then((r) => {
      const v = r.data?.logo_url?.value;
      if (v && v.trim()) {
        setUrl(v.startsWith("http") ? v : `${API}${v.startsWith("/api") ? v.slice(4) : v}`);
      }
    }).catch(() => {});
  }, []);
  return url;
}
